import { useState, useContext, useEffect } from "react";
import {
  Grid,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const NewWaiverDialog = ({ open, close, save }) => {
  const [name, setName] = useState("");

  return (
    <Dialog open={open} onClose={close} fullWidth>
      <DialogTitle>Save New Waiver</DialogTitle>
      <DialogContent
        style={{ display: "flex", flexDirection: "column", gap: 20 }}
      >
        <Typography>Please enter a name for the new waiver</Typography>
        <TextField
          value={name}
          onChange={(e) => setName(e.target.value)}
          size="small"
          label="Waiver Title"
        ></TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={() => save(name)}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewWaiverDialog;
